/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import {
  getEventBraindatePods,
  getEventBraindateMeetingPoint,
  getEventGroupBraindatePods,
  getEventGroupBraindateMeetingPoint,
} from '@e180/domain/lib/event/util';

import {
  getSelfCheckinOneOnOnePodIcons,
  getSelfCheckinGroupPodIcons,
} from 'plugin/self-checkin/util/selfCheckinUtils';
import { getDisplayName } from 'src/shared/core/component/hoc/util/hocUtil';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { BraindateEvent } from '@e180/domain/lib/event/type';
import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // Self passed
  braindateEvent: BraindateEvent,
  // $FlowIssue
  intl: intlShape,
};

export default function withMeetingPoints(WrappedComponent: any): any {
  const WithMeetingPointsComponent = (props: Props): React.Node => {
    const { braindateEvent, intl } = props;

    const { locale } = intl;
    const oneOneOnePodNames = getEventBraindatePods(braindateEvent, locale);
    const groupPodNames = getEventGroupBraindatePods(braindateEvent, locale);
    const oneOneOnePodIcons = getSelfCheckinOneOnOnePodIcons(braindateEvent);
    const groupPodIcons = getSelfCheckinGroupPodIcons(braindateEvent);

    /*
     |----------------------------------------------------------------------------
     | Elements
     |----------------------------------------------------------------------------
     */

    return (
      <WrappedComponent
        {...props}
        braindateMeetingPoint={getEventBraindateMeetingPoint(
          braindateEvent,
          locale,
        )}
        groupBraindateMeetingPoint={getEventGroupBraindateMeetingPoint(
          braindateEvent,
          locale,
        )}
        oneOneOnePodNames={oneOneOnePodNames}
        groupPodNames={groupPodNames}
        oneOneOnePodIcons={oneOneOnePodIcons}
        groupPodIcons={groupPodIcons}
      />
    );
  };

  WithMeetingPointsComponent.displayName = `WithMeetingPointsComponent(${getDisplayName(
    WrappedComponent,
  )})`;

  return compose(
    injectIntl,
    connect((state: State): any => ({ braindateEvent: getEventSafely(state) })),
  )(WithMeetingPointsComponent);
}
